{
  "filter": {
    "all": "All",
    "country": "Country",
    "direct": "Direct",
    "indirectConfidential": "Indirect & confidential",
    "nonConfidential": "Indirect & non-confidential"
  },
  "list": {
    "countContact_one": "{{count}} Contact",
    "countContact_other": "{{count}} Contacts",
    "noAddress": "No address",
    "noSuppliers": "No result",
    "searchPlaceholder": "Alias, company, etc.",
    "supplierTypePlaceholder": "All"
  },
  "productionSites": {
    "columns": {
      "confidential": "Confidential",
      "contactEmail": "Contact email",
      "country": "Location",
      "internalCode": "Internal code",
      "name": "Facility name",
      "parentCompany": "Parent business partner",
      "performedActivities": "Performed activities",
      "registrationId": "Registration ID"
    },
    "filters": {
      "searchPlaceholder": "Alias, company, etc."
    },
    "search": {
      "placeholder": "Alias, company, etc."
    },
    "title": "Production sites"
  },
  "repository": {
    "actions": {
      "delete": "Delete",
      "edit": "Edit"
    },
    "create": {
      "error": {
        "message": "The business partner has not been created",
        "title": "Error creating business partner"
      },
      "success": {
        "message": "The business partner has been created successfully",
        "title": "Business partner created"
      }
    },
    "delete": {
      "error": {
        "message": "The business partner has not been deleted",
        "title": "Error deleting business partner"
      },
      "success": {
        "message": "The business partner has been deleted successfully",
        "title": "Business partner deleted"
      }
    },
    "title": "All",
    "update": {
      "error": {
        "message": "The business partner has not been updated",
        "title": "Error updating business partner"
      },
      "success": {
        "message": "The business partner has been updated successfully",
        "title": "Business partner updated"
      }
    }
  },
  "risk": {
    "high": "High",
    "low": "Low",
    "medium": "Medium",
    "table": {
      "certificationRisk": {
        "title": "Audit & Certification risk",
        "tooltip": "Assesses the partner's compliance status based on collection of certificates and audit results"
      },
      "collaborationRisk": {
        "title": "Collaboration risk",
        "tooltip": "Assesses the partner's engagement level on the platform (completion rate and speed of responses to traceability requests)"
      }
    }
  },
  "sort": {
    "averageResponseTime": "Average response time",
    "company": "Company",
    "completedProductionSiterequests": "Closed production site requests",
    "completedProductrequests": "Closed product requests",
    "completedScopeCertificaterequests": "Closed scope certificate requests",
    "completedTransactionCertificaterequests": "Closed transaction certificate requests",
    "email": "Email",
    "lastConnectionDate": "Last connection",
    "lastReminderDate": "Last reminder",
    "name": "Name",
    "pendingDocumentrequests": "Pending requests (document)",
    "pendingProductionSiterequests": "Pending requests (facility)",
    "pendingProductrequests": "Pending requests (product)",
    "pendingScopeCertificaterequests": "Pending scope certificate requests",
    "pendingTransactionCertificaterequests": "Pending transaction certificate requests"
  },
  "subSuppliers": {
    "title": "All"
  },
  "supplier": {
    "averageResponseTime": "Average response time",
    "averageResponseTimeValue_one": "{{nbDays}} day",
    "averageResponseTimeValue_other": "{{nbDays}} days",
    "informationRequests": "Product requests",
    "lastConnection": "Last connection",
    "lastConnectionValue": "{{nbDays}} days ago",
    "lastReminderSent": "Last reminder",
    "lastReminderSentValue": "{{nbDays}} days ago",
    "noLastConnection": "None",
    "noLastReminderSent": "None",
    "noResponseTime": "No response",
    "productionSites": "Production Sites",
    "scopeCertificates": "Certificates & Audits",
    "transactionCertificates": "Transaction Proofs",
    "transferContact_one": "Transfer {{count}} uncompleted traceability request.",
    "transferContact_other": "Transfer {{count}} uncompleted traceability requests.",
    "transferContactCertificates_one": "Transfer {{count}} uncompleted certificate request.",
    "transferContactCertificates_other": "Transfer {{count}} uncompleted certificate requests.",
    "transferModal": {
      "companyCountry": "Country",
      "companyCountryPlaceholder": "France",
      "companyName": "Company",
      "companyNamePlaceholder": "Trace for good",
      "email": "Contact Email",
      "emailPlaceholder": "support@traceforgood.com",
      "name": "Alias",
      "namePlaceholder": "John Doe",
      "title": "Transfer pending requests",
      "transfer": "Transfer",
      "transferSuccess_one": "{{count}} request have been transferred to selected contact",
      "transferSuccess_other": "{{count}} requests have been transferred to selected contact"
    }
  },
  "title": "Business Partners"
}
